import { compose } from "@insightfulscience/shared-utils/fn";
import { isExpectedGqlError } from "@insightfulscience/shared-utils/gqlClient/GqlError";

const raise = err => {
	throw err;
};
/** @type {(isExpected: <E extends Error>(err: E) => boolean) => <E extends Error>(err: E) => string} */
const catchExpectedGqlError = isExpected => err =>
	isExpected(err) ? `graphql:${err.path}.${err.code}` : raise(err);
/** @type {(...expected: number[]) => <E extends Error>(err: E) => string} */

export const expectGqlError = compose(catchExpectedGqlError, isExpectedGqlError);
